import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import productsFrame from "./products/ProductsFrame";
import productsDjembe from "./products/ProductsDjembe";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App products={productsFrame} productsDjembe={productsDjembe}/>
  </React.StrictMode>
);

